//
//
//
//
//
//
//
//
//
//

export default {
    inject: ['baseUrl', 'tidalUrl'],
    inheritAttrs: false,
    props: {
        href: {
            type: String,
            default: null,
        },
        isNuxt: {
            type: Boolean,
            default: false,
        },
        external: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /** @return {boolean} */
        _isNuxt() {
            return this.isNuxt && !this.external;
        },
        /** @return {string | null} */
        _href() {
            if (this.disabled) {
                return null;
            }

            const href = this.href && this.href !== '/' ? this.href : '';
            if (this.external) {
                return href;
            }

            const baseUrl = this.baseUrl || '/';

            if (this.isNuxt) {
                return baseUrl + href;
            }

            return (this.tidalUrl || baseUrl) + href;
        },
    },
};
